import { render, staticRenderFns } from "./AdvisorCoreNavLink.vue?vue&type=template&id=707e1810&scoped=true&"
import script from "./AdvisorCoreNavLink.vue?vue&type=script&lang=js&"
export * from "./AdvisorCoreNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707e1810",
  null
  
)

export default component.exports